export default class Address {
  constructor (chAddress) {
    if (chAddress) {
      this.addressLine1 = chAddress.address_line_1
      if (chAddress.premises) {
        if (chAddress.address_line_1) {
          const divider = parseInt(chAddress.premises) ? ' ' : ', '
          this.addressLine1 = [chAddress.premises, chAddress.address_line_1].join(divider)
        } else this.addressLine1 = chAddress.premises
      }
      this.city = chAddress.locality
      if (!chAddress.locality && chAddress.address_line_2) this.city = chAddress.address_line_2
      else this.addressLine2 = chAddress.address_line_2
      this.postcode = chAddress.postal_code
      switch (chAddress.country) {
        case 'England':
        case 'Scotland':
        case 'Wales':
          this.country = 'United Kingdom'
          break
        default:
          this.country = chAddress.country ? chAddress.country : 'United Kingdom'
      }
      this.isSuggested = true
    } else {
      this.addressLine1 = ''
      this.city = ''
      this.postcode = ''
      this.country = ''
      this.isSuggested = false
    }
  }

  static stringify (a) {
    if (a.addressLine2) return [a.addressLine1, a.addressLine2, a.city, a.postcode, a.country].join(', ')
    else return [a.addressLine1, a.city, a.postcode, a.country].join(', ')
  }
}
